import { FabMenuItemsTypes, FabMenuPropertiesTypes } from "@website/ui/fab-menu/fab-bar.type";
import get from "lodash-es/get";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
export const useTopBar = ({
  items
}: FabMenuPropertiesTypes) => {
  const router = useRouter();
  const [scrolledItem, setScrolledItem] = useState("");
  const [scrolledItems, setScrolledItems] = useState({});
  const [clickedItem, setClickedItem] = useState<Record<string, string>>({});
  const handleClick = (item: FabMenuItemsTypes) => () => {
    setClickedItem(item);
    window?.scrollTo({
      top: (document.querySelector<HTMLDivElement>(item?.selector)?.offsetTop as number) - (process.env.NEXT_PUBLIC_APP_NAME === "villa" ? -200 : 55),
      behavior: "smooth"
    });
  };
  useEffect(() => {
    const list = items?.map(({
      selector
    }) => {
      const element = document.querySelector<HTMLDivElement>(selector);
      const observer = new IntersectionObserver(([entry]) => {
        clickedItem?.title ? setScrolledItems(state => ({
          ...Object.fromEntries(Object.keys(state).map(key => [key, false])),
          [clickedItem?.selector]: true
        })) : setScrolledItems(state_0 => ({
          ...state_0,
          [selector]: entry.isIntersecting
        }));
      }, {
        threshold: process.env.NEXT_PUBLIC_APP_NAME === "villa" ? 0.5 : undefined
      });
      element && observer?.observe(element);
      return () => {
        element && observer?.unobserve(element);
      };
    });
    return () => void list?.map(unobserve => unobserve());
  }, [items, router?.query, clickedItem]);
  useEffect(() => {
    if (clickedItem?.title) window.addEventListener("scrollend", () => {
      setClickedItem({});
    });
  }, [setScrolledItem, scrolledItems]);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScrolledItem(toString(items?.find(({
        selector: selector_0
      }) => get(scrolledItems, selector_0) === true)?.title));
    });
  }, [items, scrolledItems]);
  return {
    scrolledItem,
    handleClick
  };
};